import * as Web3 from 'web3';
import { Web3Utils } from './web3_utils';

import { TxData } from '../types';

export async function generateTxOptions(
    web3: Web3,
    gas: number,
    options?: TxData
): Promise<TxData> {
    const web3Utils = new Web3Utils(web3);
    const accounts = await web3Utils.getAvailableAddressesAsync();

    return {
        gas,
        from: accounts[0],
        ...options
    }
}
